import { TextField, Typography, Box } from '@mui/material';

import React, { useCallback, useEffect, useState } from 'react';

import styles from '../JobScheduler.module.scss';

import RadioGroupComp from '../../../../common/components/RadioGroup/RadioGroupComp';
import SelectComponent from '../../../../common/components/SelectNumComp/SelectComponent';

import TimeComp from './TimeComp';

interface IYearlyProps {
	monthOfYear?: number | string;
	dayOfMonth?: number | string;
	dayOfWeek?: string | number;
	weekOfMonth?: number | string;
	startsAtHour?: string | number;
	startsAtMinutes?: string | number;
}

interface IYearlyCompProps {
	handleChange: (val: number | string | IYearlyProps) => void;
}

type OptionType = {
	value: number | string;
	label: number | string;
};

const monthList: OptionType[] = [
	{ label: 'January', value: 1 },
	{ label: 'February', value: 2 },
	{ label: 'March', value: 3 },
	{ label: 'April', value: 4 },
	{ label: 'May', value: 5 },
	{ label: 'June', value: 6 },
	{ label: 'July', value: 7 },
	{ label: 'August', value: 8 },
	{ label: 'September', value: 9 },
	{ label: 'October', value: 10 },
	{ label: 'November', value: 11 },
	{ label: 'December', value: 12 },
];

const weekList: OptionType[] = [
	{ label: 'First', value: 1 },
	{ label: 'Second', value: 2 },
	{ label: 'Third', value: 3 },
	{ label: 'Fourth', value: 4 },
];

const daysList: OptionType[] = [
	{ label: 'Monday', value: 'Monday' },
	{ label: 'Tuesday', value: 'Tuesday' },
	{ label: 'Wednesday', value: 'Wednesday' },
	{ label: 'Thursday', value: 'Thursday' },
	{ label: 'Friday', value: 'Friday' },
	{ label: 'Saturday', value: 'Saturday' },
	{ label: 'Sunday', value: 'Sunday' },
];

const YearlyComp = (props: IYearlyCompProps) => {
	const { handleChange } = props;
	const [dayOfMonth, setDayOfMonth] = useState<number | string>('1');
	const [monthOfYear, setMonthOfYear] = useState<number | string>(1);
	const [weekOfMonth, setWeekOfMonth] = useState<number | string>(1);
	const [dayOfWeek, setDayOfWeek] = useState<string | number>('Monday');
	const [radioSelection, setRadioSelection] = useState<string | number>(
		'everyMonth',
	);
	const [hour, setHour] = useState<string | number>('12');
	const [minutes, setMinutes] = useState<string | number>('00');

	const handleRadioSelection = useCallback((val: string | number) => {
		setRadioSelection(val);
	}, []);

	const onDayOfMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setDayOfMonth(e.target.value);
	};
	const handleMonthChange = useCallback((val: number | string) => {
		setMonthOfYear(val);
	}, []);

	const handleWeekChange = useCallback((val: number | string) => {
		setWeekOfMonth(val);
	}, []);

	const handleDayChange = useCallback((val: number | string) => {
		setDayOfWeek(val);
	}, []);

	const handleHourChange = useCallback((val: string | number) => {
		setHour(val);
	}, []);

	const handleMinuteChange = useCallback((val: string | number) => {
		setMinutes(val);
	}, []);

	const getEveryMonthLabel = () => (
		<Box className={styles['select-align']}>
			<Typography>Every</Typography>
			<SelectComponent
				type="number"
				defaultValue={monthOfYear}
				selectList={monthList}
				handleValueChange={handleMonthChange}
			/>
			<TextField
				className={styles['textfield-width']}
				size="small"
				fullWidth={false}
				name="dayOfMonth"
				value={dayOfMonth}
				type="string"
				onChange={onDayOfMonthChange}
				inputProps={{
					style: {
						height: '23px',
					},
				}}
			/>
		</Box>
	);
	const getSpecificMonthLabel = () => (
		<Box className={styles['select-align']}>
			<Typography>The</Typography>
			<SelectComponent
				type="string"
				defaultValue={weekOfMonth}
				selectList={weekList}
				handleValueChange={handleWeekChange}
			/>
			<SelectComponent
				type="string"
				defaultValue={dayOfWeek}
				selectList={daysList}
				handleValueChange={handleDayChange}
			/>
			<Typography>of</Typography>
			<SelectComponent
				type="string"
				defaultValue={monthOfYear}
				selectList={monthList}
				handleValueChange={handleMonthChange}
			/>
		</Box>
	);
	const monthSelection = [
		{ value: 'everyMonth', label: getEveryMonthLabel() },
		{ value: 'specificMonth', label: getSpecificMonthLabel() },
	];
	useEffect(() => {
		let obj: IYearlyProps = {
			monthOfYear,
			dayOfMonth,
			dayOfWeek,
			weekOfMonth,
			startsAtHour: hour,
			startsAtMinutes: minutes,
		};
		if (
			radioSelection === 'everyMonth' &&
			dayOfMonth !== undefined &&
			hour !== undefined &&
			minutes !== undefined &&
			monthOfYear !== undefined
		) {
			obj = {
				monthOfYear,
				dayOfMonth: Number(dayOfMonth),
				startsAtHour: hour,
				startsAtMinutes: minutes,
			};
		} else if (
			radioSelection === 'specificMonth' &&
			weekOfMonth !== undefined &&
			dayOfWeek !== undefined &&
			hour !== undefined &&
			minutes !== undefined &&
			monthOfYear !== undefined
		) {
			obj = {
				monthOfYear,
				dayOfWeek,
				weekOfMonth,
				startsAtHour: hour,
				startsAtMinutes: minutes,
			};
		}
		handleChange(obj);
	}, [
		radioSelection,
		monthOfYear,
		hour,
		minutes,
		dayOfMonth,
		weekOfMonth,
		dayOfWeek,
	]);

	return (
		<>
			<RadioGroupComp
				type="string"
				optionSelection={monthSelection}
				defaultValue={radioSelection}
				handleValueChange={handleRadioSelection}
			/>
			<TimeComp
				handleHourChange={handleHourChange}
				handleMinuteChange={handleMinuteChange}
			/>
		</>
	);
};

export default YearlyComp;
